// Template Detail Page - Edit template and add exercises

import { query, run, saveDatabase } from "../db.js";
import { navigateTo, showToast, showConfirmDialog } from "../router.js";

export async function renderTemplateDetailPage(params) {
  const templateId = params.id;
  const app = document.getElementById("app");

  const template = query("SELECT * FROM Template WHERE id = ?", [
    templateId,
  ])[0];

  if (!template) {
    showToast("Template not found", "error");
    navigateTo("/templates");
    return;
  }

  const workoutExercises = query(
    `
    SELECT we.*, e.name, e.musclegroup, e.equipment, e.exercise_type, e.color
    FROM PlannedExercises we
    JOIN Exercises e ON we.exercise_id = e.id
    WHERE we.workout_id = ?
    ORDER BY we.id
  `,
    [templateId]
  );

  const allExercises = query(
    "SELECT * FROM Exercises ORDER BY musclegroup, name"
  );

  app.innerHTML = `
    <div class="page safe-top">
      <!-- Header -->
      <div class="page-header">
        <div class="page-header-top">
          <button class="btn-ghost" style="margin-left: -12px;" id="back-btn">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <line x1="19" y1="12" x2="5" y2="12"></line>
              <polyline points="12 19 5 12 12 5"></polyline>
            </svg>
          </button>
          <div style="flex: 1; display: flex; align-items: center; gap: var(--spacing-xs);">
            <h1 class="page-title" id="template-name-display">${template.name}</h1>
            <button class="btn-ghost" style="padding: var(--spacing-xs);" id="edit-name-btn" title="Edit template name">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
              </svg>
            </button>
            <input type="text" id="template-name-input" value="${template.name}" style="display: none; flex: 1; max-width: 300px;" />
          </div>
          <button class="btn-primary btn-sm" id="start-workout-btn">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <polygon points="5 3 19 12 5 21 5 3"></polygon>
            </svg>
            Start
          </button>
        </div>
        ${
          template.notes
            ? `
          <p class="text-sm text-muted" style="margin-top: var(--spacing-sm);">
            ${template.notes}
          </p>
        `
            : ""
        }
      </div>

      <div style="padding: 0 var(--spacing-md); margin-bottom: var(--spacing-xl);">
        <!-- Add Exercise Button -->
        <button class="btn-primary w-full mb-4" id="add-exercise-btn">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <line x1="12" y1="5" x2="12" y2="19"></line>
            <line x1="5" y1="12" x2="19" y2="12"></line>
          </svg>
          Add Exercise
        </button>

        <!-- Exercises List -->
        ${
          workoutExercises.length > 0
            ? `
          <div id="exercises-list">
            ${workoutExercises
              .map((we, index) => renderWorkoutExercise(we, index + 1))
              .join("")}
          </div>
        `
            : `
          <div class="empty-state">
            <p class="text-muted">No exercises added yet</p>
          </div>
        `
        }
      </div>
    </div>

    <!-- Add Exercise Modal -->
    <div id="add-exercise-modal" class="modal-overlay" style="display: none;">
      <div class="modal">
        <div class="modal-header">
          <h2 class="modal-title">Add Exercise</h2>
          <button class="modal-close" id="close-exercise-modal">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>
        <div class="modal-body">
          <div style="margin-bottom: var(--spacing-md);">
            <label style="display: block; margin-bottom: var(--spacing-xs); font-weight: 500;">
              Search Exercise
            </label>
            <input type="text" id="exercise-search" placeholder="Search exercises..." autofocus />
          </div>
          <div style="max-height: 400px; overflow-y: auto;">
            <div id="exercise-list">
              ${renderExerciseList(allExercises)}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Add Sets Modal -->
    <div id="add-sets-modal" class="modal-overlay" style="display: none;">
      <div class="modal">
        <div class="modal-header">
          <h2 class="modal-title">Add Sets</h2>
          <button class="modal-close" id="close-sets-modal">
            <svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>
        <div class="modal-body">
          <p class="text-sm text-muted mb-4" id="sets-exercise-name"></p>

          <div style="display: grid; grid-template-columns: 1fr 1fr 1fr; gap: var(--spacing-md); margin-bottom: var(--spacing-md);">
            <div>
              <label style="display: block; margin-bottom: var(--spacing-xs); font-weight: 500;">Sets</label>
              <input type="number" id="num-sets" value="3" min="1" max="10" />
            </div>
            <div>
              <label style="display: block; margin-bottom: var(--spacing-xs); font-weight: 500;">Weight (kg)</label>
              <input type="number" id="set-weight" value="0" step="0.5" min="0" />
            </div>
            <div>
              <label style="display: block; margin-bottom: var(--spacing-xs); font-weight: 500;">Reps</label>
              <input type="number" id="set-reps" value="8" min="1" max="100" />
            </div>
          </div>

          <div id="sets-preview" style="margin-bottom: var(--spacing-md);"></div>
        </div>
        <div class="modal-footer">
          <button class="btn-ghost" id="cancel-sets-btn">Cancel</button>
          <button class="btn-primary" id="save-sets-btn">Add Sets</button>
        </div>
      </div>
    </div>
  `;

  // Event listeners
  document
    .getElementById("back-btn")
    ?.addEventListener("click", () => navigateTo("/templates"));
  document
    .getElementById("start-workout-btn")
    ?.addEventListener("click", () => navigateTo(`/workout/${templateId}`));

  setupEditTemplateName(templateId);
  setupAddExerciseModal(templateId, allExercises);
  setupDeleteExercise(templateId);
  setupAddSetsButtons(templateId);
}

function setupEditTemplateName(templateId) {
  const editBtn = document.getElementById("edit-name-btn");
  const nameDisplay = document.getElementById("template-name-display");
  const nameInput = document.getElementById("template-name-input");

  let isEditing = false;

  const startEditing = () => {
    if (isEditing) return;
    isEditing = true;
    nameDisplay.style.display = "none";
    editBtn.style.display = "none";
    nameInput.style.display = "block";
    nameInput.focus();
    nameInput.select();
  };

  const cancelEditing = () => {
    isEditing = false;
    nameDisplay.style.display = "block";
    editBtn.style.display = "block";
    nameInput.style.display = "none";
    // Reset input to current name
    const template = query("SELECT name FROM Template WHERE id = ?", [templateId])[0];
    nameInput.value = template?.name || "";
  };

  const saveEdit = async () => {
    const newName = nameInput.value.trim();

    if (!newName) {
      showToast("Template name cannot be empty", "error");
      nameInput.focus();
      return;
    }

    try {
      run("UPDATE Template SET name = ? WHERE id = ?", [newName, templateId]);
      await saveDatabase();
      showToast("Template name updated", "success");
      nameDisplay.textContent = newName;
      isEditing = false;
      nameDisplay.style.display = "block";
      editBtn.style.display = "block";
      nameInput.style.display = "none";
    } catch (err) {
      console.error("Failed to update template name:", err);
      showToast("Failed to update template name", "error");
    }
  };

  editBtn?.addEventListener("click", startEditing);

  nameInput?.addEventListener("keydown", (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      saveEdit();
    } else if (e.key === "Escape") {
      e.preventDefault();
      cancelEditing();
    }
  });

  nameInput?.addEventListener("blur", () => {
    // Small delay to allow clicking other elements
    setTimeout(() => {
      if (isEditing) {
        saveEdit();
      }
    }, 100);
  });
}

function renderWorkoutExercise(we, index) {
  const sets = query(
    `
    SELECT * FROM PlannedSets WHERE workout_exercise_id = ? ORDER BY id
  `,
    [we.id]
  );

  return `
    <div class="exercise-card" style="margin-bottom: var(--spacing-md);">
      <div class="exercise-card-header">
        <div class="exercise-number">${index}</div>
        <div style="flex: 1;">
          <div class="exercise-name">${we.name}</div>
          <div class="exercise-meta">${we.musclegroup} · ${we.equipment}</div>
        </div>
        <button class="btn-ghost btn-sm" data-delete-exercise="${we.id}">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <polyline points="3 6 5 6 21 6"></polyline>
            <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
          </svg>
        </button>
      </div>

      ${
        sets.length > 0
          ? `
        <div style="margin-top: var(--spacing-sm);">
          ${sets
            .map(
              (set, idx) => `
            <div style="display: flex; justify-content: space-between; padding: var(--spacing-sm); background: var(--color-surface); border-radius: var(--radius-md); margin-bottom: var(--spacing-xs);">
              <span class="text-sm">Set ${idx + 1}</span>
              <span class="stat-number text-sm">${formatSetDisplay(set.weight, set.reps, set.duration_seconds, we.exercise_type)}</span>
            </div>
          `
            )
            .join("")}
        </div>
      `
          : ""
      }

      <button class="btn-primary btn-sm w-full" data-add-sets="${
        we.id
      }" data-exercise-name="${we.name}" data-exercise-type="${we.exercise_type || 'weight_reps'}" style="margin-top: var(--spacing-sm);">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <line x1="12" y1="5" x2="12" y2="19"></line>
          <line x1="5" y1="12" x2="19" y2="12"></line>
        </svg>
        ${sets.length > 0 ? "Add More Sets" : "Add Sets"}
      </button>
    </div>
  `;
}

function renderExerciseList(exercises) {
  let lastMuscleGroup = "";
  let html = "";

  exercises.forEach((ex) => {
    if (ex.musclegroup !== lastMuscleGroup) {
      html += `<h3 class="text-sm text-muted" style="margin: var(--spacing-md) 0 var(--spacing-sm); text-transform: capitalize;">${ex.musclegroup}</h3>`;
      lastMuscleGroup = ex.musclegroup;
    }

    html += `
      <div class="exercise-list-item" data-exercise-id="${ex.id}" style="padding: var(--spacing-md); border-bottom: 1px solid var(--color-border); cursor: pointer; transition: background var(--transition-base);">
        <div style="font-weight: 500;">${ex.name}</div>
        <div class="text-sm text-muted">${ex.equipment}</div>
      </div>
    `;
  });

  return html;
}

function setupAddExerciseModal(templateId, allExercises) {
  const addBtn = document.getElementById("add-exercise-btn");
  const modal = document.getElementById("add-exercise-modal");
  const closeBtn = document.getElementById("close-exercise-modal");
  const searchInput = document.getElementById("exercise-search");
  const exerciseList = document.getElementById("exercise-list");

  const openModal = () => {
    modal.style.display = "flex";
    searchInput.value = "";
    exerciseList.innerHTML = renderExerciseList(allExercises);
    setupExerciseListeners(templateId, modal);
    setTimeout(() => searchInput.focus(), 100);
  };

  const closeModal = () => {
    modal.style.display = "none";
  };

  addBtn?.addEventListener("click", openModal);
  closeBtn?.addEventListener("click", closeModal);
  modal?.addEventListener("click", (e) => {
    if (e.target === modal) closeModal();
  });

  searchInput?.addEventListener("input", () => {
    const searchTerm = searchInput.value.toLowerCase();
    const filtered = allExercises.filter(
      (ex) =>
        ex.name.toLowerCase().includes(searchTerm) ||
        ex.musclegroup.toLowerCase().includes(searchTerm)
    );
    exerciseList.innerHTML = renderExerciseList(filtered);
    setupExerciseListeners(templateId, modal);
  });
}

function setupExerciseListeners(templateId, modal) {
  document.querySelectorAll(".exercise-list-item").forEach((item) => {
    item.addEventListener("click", async () => {
      const exerciseId = item.getAttribute("data-exercise-id");

      try {
        run(
          "INSERT INTO PlannedExercises (workout_id, exercise_id) VALUES (?, ?)",
          [templateId, exerciseId]
        );
        await saveDatabase();
        showToast("Exercise added", "success");
        modal.style.display = "none";
        renderTemplateDetailPage({ id: templateId });
      } catch (err) {
        console.error("Failed to add exercise:", err);
        showToast("Failed to add exercise", "error");
      }
    });
  });
}

function setupDeleteExercise(templateId) {
  document.querySelectorAll("[data-delete-exercise]").forEach((btn) => {
    btn.addEventListener("click", async () => {
      const workoutExerciseId = btn.getAttribute("data-delete-exercise");

      const confirmed = await showConfirmDialog(
        "Remove this exercise from the template?",
        "Remove"
      );

      if (confirmed) {
        try {
          run("DELETE FROM PlannedExercises WHERE id = ?", [workoutExerciseId]);
          await saveDatabase();
          showToast("Exercise removed", "success");
          renderTemplateDetailPage({ id: templateId });
        } catch (err) {
          console.error("Failed to delete exercise:", err);
          showToast("Failed to delete exercise", "error");
        }
      }
    });
  });
}

function setupAddSetsButtons(templateId) {
  document.querySelectorAll("[data-add-sets]").forEach((btn) => {
    btn.addEventListener("click", () => {
      const workoutExerciseId = btn.getAttribute("data-add-sets");
      const exerciseName = btn.getAttribute("data-exercise-name");
      const exerciseType = btn.getAttribute("data-exercise-type") || 'weight_reps';
      openAddSetsModal(templateId, workoutExerciseId, exerciseName, exerciseType);
    });
  });
}

function openAddSetsModal(templateId, workoutExerciseId, exerciseName, exerciseType = 'weight_reps') {
  const modal = document.getElementById("add-sets-modal");
  const closeBtn = document.getElementById("close-sets-modal");
  const cancelBtn = document.getElementById("cancel-sets-btn");
  const saveBtn = document.getElementById("save-sets-btn");
  const exerciseNameEl = document.getElementById("sets-exercise-name");
  const numSetsInput = document.getElementById("num-sets");
  const preview = document.getElementById("sets-preview");

  exerciseNameEl.textContent = exerciseName;

  // For time-based exercises
  if (exerciseType === 'time_based') {
    const weightInput = document.getElementById("set-weight");
    const repsInput = document.getElementById("set-reps");

    // Hide weight/reps inputs and create time inputs
    if (weightInput) weightInput.parentElement.style.display = 'none';
    if (repsInput) repsInput.parentElement.style.display = 'none';

    // Check if time inputs already exist, if not create them
    let minutesInput = document.getElementById("set-minutes");
    let secondsInput = document.getElementById("set-seconds");

    if (!minutesInput) {
      const inputsContainer = weightInput.parentElement.parentElement;
      const timeInputsHTML = `
        <div class="form-group">
          <label>Minutes</label>
          <input type="number" id="set-minutes" value="1" min="0" max="60" />
        </div>
        <div class="form-group">
          <label>Seconds</label>
          <input type="number" id="set-seconds" value="0" min="0" max="59" />
        </div>
      `;
      inputsContainer.insertAdjacentHTML('beforeend', timeInputsHTML);
      minutesInput = document.getElementById("set-minutes");
      secondsInput = document.getElementById("set-seconds");
    } else {
      minutesInput.parentElement.style.display = 'block';
      secondsInput.parentElement.style.display = 'block';
    }

    const updatePreview = () => {
      const numSets = parseInt(numSetsInput.value) || 0;
      const minutes = parseInt(minutesInput.value) || 0;
      const seconds = parseInt(secondsInput.value) || 0;
      const totalSeconds = minutes * 60 + seconds;

      preview.innerHTML = `
        <p class="text-sm text-muted mb-2">Preview:</p>
        ${Array.from({ length: numSets }, (_, i) => `
          <div style="display: flex; justify-content: space-between; padding: var(--spacing-sm); background: var(--color-surface); border-radius: var(--radius-md); margin-bottom: var(--spacing-xs);">
            <span class="text-sm">Set ${i + 1}</span>
            <span class="stat-number text-sm">${formatSetDuration(totalSeconds)}</span>
          </div>
        `).join("")}
      `;
    };

    updatePreview();
    numSetsInput.addEventListener("input", updatePreview);
    minutesInput.addEventListener("input", updatePreview);
    secondsInput.addEventListener("input", updatePreview);

    const closeModal = () => {
      modal.style.display = "none";
    };

    closeBtn.onclick = closeModal;
    cancelBtn.onclick = closeModal;
    modal.onclick = (e) => {
      if (e.target === modal) closeModal();
    };

    saveBtn.onclick = async () => {
      const numSets = parseInt(numSetsInput.value) || 0;
      const minutes = parseInt(minutesInput.value) || 0;
      const seconds = parseInt(secondsInput.value) || 0;
      const totalSeconds = minutes * 60 + seconds;

      if (numSets < 1) {
        showToast("Please enter at least 1 set", "error");
        return;
      }

      if (totalSeconds < 1) {
        showToast("Please enter a duration", "error");
        return;
      }

      try {
        for (let i = 0; i < numSets; i++) {
          run(
            "INSERT INTO PlannedSets (workout_exercise_id, duration_seconds) VALUES (?, ?)",
            [workoutExerciseId, totalSeconds]
          );
        }

        await saveDatabase();
        showToast(`${numSets} set(s) added`, "success");
        closeModal();
        renderTemplateDetailPage({ id: templateId });
      } catch (err) {
        console.error("Failed to add sets:", err);
        showToast("Failed to add sets", "error");
      }
    };
  } else {
    // For weight/reps exercises
    const weightInput = document.getElementById("set-weight");
    const repsInput = document.getElementById("set-reps");

    // Show weight/reps inputs, hide time inputs if they exist
    if (weightInput) weightInput.parentElement.style.display = 'block';
    if (repsInput) repsInput.parentElement.style.display = 'block';

    const minutesInput = document.getElementById("set-minutes");
    const secondsInput = document.getElementById("set-seconds");
    if (minutesInput) minutesInput.parentElement.style.display = 'none';
    if (secondsInput) secondsInput.parentElement.style.display = 'none';

    const updatePreview = () => {
      const numSets = parseInt(numSetsInput.value) || 0;
      const weight = parseFloat(weightInput.value) || 0;
      const reps = parseInt(repsInput.value) || 0;

      preview.innerHTML = `
        <p class="text-sm text-muted mb-2">Preview:</p>
        ${Array.from({ length: numSets }, (_, i) => `
          <div style="display: flex; justify-content: space-between; padding: var(--spacing-sm); background: var(--color-surface); border-radius: var(--radius-md); margin-bottom: var(--spacing-xs);">
            <span class="text-sm">Set ${i + 1}</span>
            <span class="stat-number text-sm">${formatSetDisplay(weight, reps, null, exerciseType)}</span>
          </div>
        `).join("")}
      `;
    };

    updatePreview();

    numSetsInput.addEventListener("input", updatePreview);
    weightInput.addEventListener("input", updatePreview);
    repsInput.addEventListener("input", updatePreview);

    const closeModal = () => {
      modal.style.display = "none";
    };

    closeBtn.onclick = closeModal;
    cancelBtn.onclick = closeModal;
    modal.onclick = (e) => {
      if (e.target === modal) closeModal();
    };

    saveBtn.onclick = async () => {
      const numSets = parseInt(numSetsInput.value) || 0;
      const weight = parseFloat(weightInput.value) || 0;
      const reps = parseInt(repsInput.value) || 0;

      if (numSets < 1) {
        showToast("Please enter at least 1 set", "error");
        return;
      }

      try {
        for (let i = 0; i < numSets; i++) {
          run(
            "INSERT INTO PlannedSets (workout_exercise_id, weight, reps) VALUES (?, ?, ?)",
            [workoutExerciseId, weight, reps]
          );
        }

        await saveDatabase();
        showToast(`${numSets} set(s) added`, "success");
        closeModal();
        renderTemplateDetailPage({ id: templateId });
      } catch (err) {
        console.error("Failed to add sets:", err);
        showToast("Failed to add sets", "error");
      }
    };
  }

  modal.style.display = "flex";
}

// Helper functions for exercise sets display
function formatSetDisplay(weight, reps, duration, exerciseType) {
  if (exerciseType === 'time_based') {
    return formatSetDuration(duration);
  }

  if (!weight || weight === 0) {
    return `${reps} reps`;
  }

  return `${weight} kg × ${reps}`;
}

function formatSetDuration(seconds) {
  if (!seconds) return '0s';
  if (seconds < 60) {
    return `${seconds}s`;
  }
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return secs > 0 ? `${mins}m ${secs}s` : `${mins}m`;
}
